<template>
  <div class="result">
    <div class="title">查询结果</div>
    <div class="card-container" v-if="data.length === 1">
      <el-card class="card" v-if="!data[0].archived">
        <ul>
          <li>
            <span>姓名：</span>
            <span>{{ data[0].student_name }}</span>
          </li>
          <li>
            <span>证书编号：</span>
            <span>{{ data[0].code }}</span>
          </li>
          <li>
            <span>发证时间：</span>
            <span>{{ data[0].give_time }}</span>
          </li>
          <li>
            <span>发证等级：</span>
            <span>{{ data[0].rank_result }}</span>
          </li>
          <li>
            <span>考级专业：</span>
            <span>{{ data[0].subject_title }}</span>
          </li>
          <li>
            <span>起止级：</span>
            <span>{{ data[0].subject_range }}</span>
          </li>
          <li style="text-align:center">
            <el-button style="cursor:pointer" type="danger" @click="showDetail(data[0])" plain>详情</el-button>
          </li>
        </ul>
      </el-card>
      <el-card class="card" v-else>
        <ul>
          <li>
            <span>姓名：</span>
            <span>{{ data[0].name }}</span>
          </li>
          <li v-if="data[0].gender_title">
            <span>性别：</span>
            <span>{{ data[0].gender_title }}</span>
          </li>
          <li v-if="data[0].birth">
            <span>生日：</span>
            <span>{{ data[0].birth }}</span>
          </li>
          <li>
            <span>证书编号：</span>
            <span>{{ data[0].cert_no }}</span>
          </li>
          <li v-if="data[0].granted_at">
            <span>发证时间：</span>
            <span>{{ data[0].granted_at }}</span>
          </li>
          <li v-else>
            <span>发证时间：</span>
            <span><i class="el-icon-question">&nbsp;</i></span>
          </li>
          <li>
            <span>考级专业：</span>
            <span>{{ data[0].subject_title }}</span>
          </li>
          <li>
            <span>发证等级：</span>
            <span>{{ data[0].rank }}</span>
          </li>
          <li v-if="data[0].passport">
            <span>身份证 / 护照：</span>
            <span>{{ data[0].passport }}</span>
          </li>
          <li v-else>
            <span>身份证 / 护照：</span>
            <span><i class="el-icon-question">&nbsp;</i></span>
          </li>
          <li style="text-align:center">
            <el-button @click="showDetail(data[0])" type="danger" plain>详情</el-button>
          </li>
        </ul>
      </el-card>
    </div>
    <el-table v-if="data.length != 1 && data.length != 0 && data[0].archived === true" :data="data" style="width: 96%;margin:20px auto 0" size="mini" header-row-class-name="grey" border>
      <el-table-column prop="granted_at" label="发证时间"></el-table-column>
      <el-table-column prop="cert_no" label="证书编号"></el-table-column>d
      <el-table-column label="报考科目/等级">
        <template slot-scope="scope">{{ scope.row.subject_title + scope.row.rank_result + "级" }}</template></el-table-column
      >
      <el-table-column label="操作" width="50px">
        <template slot-scope="scope">
          <div>
            <el-button type="text" size="mini" @click="showDetail(scope.row)">查看</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-table v-if="data.length != 1 && data.length != 0 && data[0].archived === false" :data="data" style="width: 96%;margin:20px auto 0" size="mini" header-row-class-name="grey" border>
      <el-table-column prop="give_time" label="发证时间"></el-table-column>
      <el-table-column prop="code" label="证书编号"></el-table-column>
      <el-table-column label="报考科目/等级">
        <template slot-scope="scope">{{ scope.row.subject_title + scope.row.rank_result + "级" }}</template></el-table-column
      >
      <el-table-column label="操作" width="50px">
        <template slot-scope="scope">
          <div>
            <el-button type="text" size="mini" @click="showDetail(scope.row)">查看</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="详情" :visible.sync="dialogVisible" top="0" width="100%" :before-close="handleClose">
      <detail :id="detailId" :archived="archived" :query_token="query_token"></detail>
    </el-dialog>
  </div>
</template>
<script>
import detail from "./detail";
export default {
  data() {
    return {
      dialogVisible: false,
      detailId: undefined,
      archived: false,
      query_token: null,
    };
  },
  methods: {
    handleClose(done) {
      done();
    },
    showDetail(item) {
      console.log(item)
      if (item.archived) {
        this.archived = item.archived;
        this.detailId = item.archived_id;
        this.query_token = item.query_token;
      } else {
        this.archived = false;
        this.detailId = item.id;
        this.query_token = item.query_token;
      }
      this.dialogVisible = true;
    },
  },
  components: {
    detail,
  },
  props: {
    data: {
      type: [Array],
      default() {
        return [];
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.result {
  border: 1px solid #eaeaea;
  margin-top: 10px;
  padding-bottom: 40px;
  .title {
    font-size: 24px;
    color: #363636;
    margin-top: 45px;
    text-align: center;
    &:after {
      content: "";
      display: block;
      width: 59px;
      height: 2px;
      background: #c9c9c9;
      margin: 0 auto;
      margin-top: 10px;
    }
  }
  .card-container {
    margin-bottom: 10px;
    .card {
      width: 80%;
      margin: 0 auto;
      padding: 20px 10px;
      li {
        margin-bottom: 15px;
        display: table;
        border-bottom: 1px solid #e7e7e7;
        padding-bottom: 15px;
        width: 100%;
        span {
          display: table-cell;
          vertical-align: baseline;

          &:first-child {
            width: 90px;
            text-align: right;
          }
          &:last-child {
            margin-left: 20px;
            text-align: left;
            word-break: break-all;
          }
        }
      }
    }
  }
}
</style>
